module.exports = __webpack_public_path__ + "static/media/jets-pizza.64ce2bd4.png";